import { store } from '@redux/store';
import { requestVerificationCode, requestVerifyCode } from '../apis/phoneVerificationService';
import { selectSpecId } from '../redux/selectors';

/**
 * Requests a verification code for the given phone number.
 * @param phoneNumber
 * @returns {Promise<*>}
 */
export function sendVerificationCode(phoneNumber) {
  const user = JSON.parse(localStorage.getItem('selfGuidedSession'));

  const state = store.getState();
  const specId = selectSpecId(state);

  return requestVerificationCode(specId, phoneNumber, user.email);
}

/**
 * Verifies the code entered by the user.
 * @param phoneNumber
 * @param code
 * @returns {Promise<void>|Promise<Awaited<{success: boolean}>>|Promise<*>}
 */
export function verifyCode(phoneNumber, code) {
  const state = store.getState();
  const specId = selectSpecId(state);
  const user = JSON.parse(localStorage.getItem('selfGuidedSession'));

  return requestVerifyCode(specId, phoneNumber, user.email, code);
}
